import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Actions } from '../actions';
import Dashboard from '../components/Connect/Topics/Topics';
import Questions from '../components/Connect/Topics/Discover';
import TopBar from '../components/TopBar/TopBar';
import './App.scss';

class Discover extends Component {
    render() {

        return (
            <div>
                <div className="Header"> Topics </div>
                <div>
                    <TopBar />
                </div>

                <div>
                    <Dashboard />
					<Questions />
                </div>
                
            </div>
        );
    }
}

const mapStateToProps = state => {
    return state;
};

export default connect(mapStateToProps, Actions)(Discover);
